import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { useApi } from "@/lib/api";

const cls = ({ isActive }) => `h-9 px-4 inline-flex items-center gap-2 rounded-full text-sm ${isActive ? "bg-ink text-bg" : "border border-line text-mute hover:text-ink"}`;

export const useUnmatchedCount = () => {
  const api = useApi();
  const [n, setN] = useState(0);
  useEffect(() => {
    const load = () => api("get", "/admin/billing/unmatched/count").then((r) => setN(r.baru)).catch(() => {});
    load();
    window.addEventListener("unmatched-changed", load);
    return () => window.removeEventListener("unmatched-changed", load);
  }, [api]);
  return n;
};

export const CountBadge = ({ n, testid }) => (n > 0 ? (
  <span data-testid={testid} title={`${n} bayaran belum diproses`}
    className="min-w-5 h-5 px-1.5 inline-flex items-center justify-center rounded-full bg-[var(--warn,#d92d20)] text-white text-[11px] font-semibold leading-none">{n}</span>
) : null);

export const AdminNav = () => {
  const n = useUnmatchedCount();
  return (
    <nav className="flex flex-wrap gap-2" data-testid="admin-nav">
      <NavLink to="/admin" end className={cls} data-testid="admin-nav-dashboard">Dashboard</NavLink>
      <NavLink to="/admin/kerangka" className={cls} data-testid="admin-nav-kerangka">Kerangka</NavLink>
      <NavLink to="/admin/tips" className={cls} data-testid="admin-nav-tips">Tips</NavLink>
      <NavLink to="/admin/bil" className={cls} data-testid="admin-nav-bil">Pengguna & bayaran <CountBadge n={n} testid="admin-nav-unmatched-count" /></NavLink>
    </nav>
  );
};
